import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRightIcon, EditIcon } from 'lucide-react';
type Product = {
  id: number;
  name: string;
  description: string;
  image: string;
  isMatching: boolean;
  intentPhrases: string[];
};
type ProductCardProps = {
  product: Product;
};
const ProductCard: React.FC<ProductCardProps> = ({
  product
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="relative" data-id="element-73">
      <motion.div animate={{
      boxShadow: product.isMatching ? '0 0 15px rgba(74, 222, 128, 0.5)' : 'none',
      borderColor: product.isMatching ? 'rgb(74, 222, 128)' : 'rgb(55, 65, 81)'
    }} className="p-3 rounded-lg bg-gray-700 border border-gray-600 cursor-pointer" onClick={() => setIsExpanded(!isExpanded)} data-id="element-74">
        <div className="flex items-center gap-3" data-id="element-75">
          <div className="w-12 h-12 rounded overflow-hidden flex-shrink-0" data-id="element-76">
            <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-77" />
          </div>
          <div className="flex-1" data-id="element-78">
            <div className="flex items-center justify-between" data-id="element-79">
              <h3 className="font-medium" data-id="element-80">{product.name}</h3>
              <div className="flex items-center gap-2" data-id="element-81">
                {product.isMatching && <motion.div initial={{
                scale: 0.5,
                opacity: 0
              }} animate={{
                scale: 1,
                opacity: 1
              }} transition={{
                duration: 0.3,
                repeat: 5,
                repeatType: 'reverse'
              }} className="w-2 h-2 rounded-full bg-green-400" data-id="element-82" />}
                <ChevronRightIcon className={`w-4 h-4 transition-transform ${isExpanded ? 'rotate-90' : ''}`} data-id="element-83" />
              </div>
            </div>
            <p className="text-sm text-gray-300" data-id="element-84">{product.description}</p>
          </div>
        </div>
      </motion.div>
      <AnimatePresence data-id="element-85">
        {isExpanded && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="mt-1 p-3 rounded-lg bg-gray-800 overflow-hidden" data-id="element-86">
            <div className="mb-3" data-id="element-87">
              <div className="flex justify-between items-center mb-2" data-id="element-88">
                <h4 className="text-sm font-medium" data-id="element-89">Intent Phrases</h4>
                <button className="text-xs flex items-center gap-1 text-blue-400 hover:text-blue-300" data-id="element-90">
                  <EditIcon className="w-3 h-3" data-id="element-91" /> Edit
                </button>
              </div>
              <ul className="text-xs space-y-1" data-id="element-92">
                {product.intentPhrases.map((phrase, index) => <li key={index} className="bg-gray-700 rounded px-2 py-1" data-id="element-93">
                    "{phrase}"
                  </li>)}
              </ul>
            </div>
            <div data-id="element-94">
              <h4 className="text-sm font-medium mb-2" data-id="element-95">Vector Stats</h4>
              <div className="grid grid-cols-2 gap-2 text-xs" data-id="element-96">
                <div className="bg-gray-700 rounded p-2" data-id="element-97">
                  <div className="text-gray-400" data-id="element-98">Matched Phrases</div>
                  <div className="font-medium" data-id="element-99">
                    {Math.floor(Math.random() * 20) + 5}
                  </div>
                </div>
                <div className="bg-gray-700 rounded p-2" data-id="element-100">
                  <div className="text-gray-400" data-id="element-101">Similarity Threshold</div>
                  <div className="font-medium" data-id="element-102">
                    {(0.7 + Math.random() * 0.2).toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export default ProductCard;